import React from 'react';

function ProgressFooter({ completedCount, totalCount, percent }) {
  if (totalCount === 0) return null;

  return (
    <div className="semesterProgressCompact">
      <div className="semesterProgressHeader">
        <span>Semester Progress</span>
        <span className="progressMeta">
          {completedCount}/{totalCount} completed ({percent}%)
        </span>
      </div>
      <div className="progressBarContainer">
        <div className="progressMilestones">
          <div className="progressTick" style={{ left: '25%' }} />
          <div className="progressTick" style={{ left: '50%' }} />
          <div className="progressTick" style={{ left: '75%' }} />
        </div>
        <div
          className="progressBarFill"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}

export default React.memo(ProgressFooter);
